import type MarketStateExportFilter from '@app/model/market_state/_export/MarketStateExportFilter';

type Group = { id?: number, name: string };
export const exportGroupNames = (ids: number[] | null | undefined, groups: Group[] = []): string[] =>
    [...new Set(ids ?? [])].sort((a, b) => a - b).map(id => groups.find(group => group.id === id)?.name ?? 'Deleted group');

export const exportGroupFileName = (ids: number[] | null | undefined, groups: Group[] = []): string => {
    const names = exportGroupNames(ids, groups);
    return names.length === 0 ? '' : 'grp_' + names.map(name =>
        name.trim().replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '').toLowerCase() || 'group').join('_');
};

export const filterFingerprint = (filter: MarketStateExportFilter): string => JSON.stringify({
    competitorTagIds: [...new Set(filter.competitorTagIds ?? [])].sort((a, b) => a - b),
    roomTypes: [...(filter.roomTypes ?? [])].sort(),
    provider: filter.provider ?? null,
    platform: filter.platform ?? null,
    region: filter.region ?? null,
    ratesType: filter.ratesType ?? null,
    guests: filter.guests ?? null,
    nights: filter.nights ?? null,
    airportCode: filter.airportCode ?? null,
    meal: filter.meal ?? null,
    refunding: filter.refunding ?? null,
});
